import React, { useState } from 'react';
import { IconButton } from '../../../../../../../../components/IconButton';
import { Application } from '../../../../../../../../entities/Application';
import { RejectCandidateStageModal } from '../../../../../../../CandidatePage/CandidateActions/RejectCandidate';
import {
  AlertObject,
  AlertType,
} from '../../../../../../../../components/Alert';
import { ConflictError } from '../../../../../../../../services/ApiService/errors/ConflictError';
import { BULK_REVIEW_NAVIGATION_TYPE } from '../../../../..';

interface PropTypes {
  application: Application;
  preSelectedRejectReasonId: number;
  disabled: boolean;
  setAlert: (alert: AlertObject) => void;
  onNext: (navType: BULK_REVIEW_NAVIGATION_TYPE) => void;
  onConflict: () => void;
  setPreSelectedRejectReasonId: (id: number) => void;
}

export function RejectApplication(props: PropTypes) {
  const [isRejectModalOpen, setIsRejectModalOpen] = useState<boolean>(false);

  const handleRejectModalClose = (
    succeeded: boolean,
    rejectedReason?: string,
    error?: Error,
  ) => {
    setIsRejectModalOpen(false);
    if (succeeded) {
      props.setAlert({
        type: AlertType.Success,
        message: (
          <span className='fw-semibold'>
            Candidate rejected with the reason &quot;{rejectedReason}&quot;.
          </span>
        ),
      });
      props.onNext('rejected');
    } else if (succeeded === false) {
      if (error instanceof ConflictError) {
        props.setAlert({
          type: AlertType.Danger,
          message: <span className='fw-semibold'>{error.body?.message}</span>,
        });
        props.onConflict();
      } else {
        props.setAlert({
          type: AlertType.Danger,
          message: (
            <span className='fw-semibold'>
              Candidate could not be rejected with the reason &quot;
              {rejectedReason}
              &quot;.
            </span>
          ),
        });
      }
    }
  };

  return (
    <>
      <RejectCandidateStageModal
        applicationId={props.application.id}
        candidateName={props.application.candidate.name}
        jobName={props.application.job?.name}
        isOpen={isRejectModalOpen}
        showConfirmationModal={false}
        filterRejectedBy='organization'
        preSelectedRejectReasonId={props.preSelectedRejectReasonId}
        currentStageId={props.application.currentJobStageId}
        onClose={(_sendEmail: boolean) => setIsRejectModalOpen(false)}
        setPreSelectedRejectReasonId={props.setPreSelectedRejectReasonId}
        onReject={handleRejectModalClose}
      />
      <IconButton
        iconName='bi-x-circle'
        buttonText='Reject'
        buttonClass='me-2h'
        color='danger'
        disabled={props.disabled}
        onClick={() => setIsRejectModalOpen(true)}
      />
    </>
  );
}
